import jsonHelper from "@core/helpers/jsonHelper";
import { StorageService } from "@core/services/storage-service";
import firebase from "@core/settings/firebase-settings";
import LoaderService from "@shared/components/loader/loader.service";
import { UserCredential } from "firebase/auth";
import { BehaviorSubject } from "rxjs";

type IState = {
  authenticated: boolean;
  user?: { email?: string };
  modules?: [];
  error?: string;
};
const stateInit: IState = {
  authenticated: false,
};

export class LoginStore {
  private storageKey = "@AuthStore";
  private loader: LoaderService;
  private _state: BehaviorSubject<IState> = new BehaviorSubject(stateInit);

  get state$() {
    return this._state.asObservable();
  }
  get state() {
    return this._state.value;
  }
  updateState(model: IState) {
    this._state.next(model);
  }

  constructor(loader: LoaderService, private storage: StorageService) {
    this.loader = loader;
    this.load();
    this.listener();
  }

  load() {
    const value = this.storage.loadFromStorage(this.storageKey);
    const valueParsed = jsonHelper.castTo<IState>(value ?? stateInit);
    if (valueParsed.authenticated !== undefined)
      this.updateState({
        authenticated: valueParsed.authenticated,
        user: valueParsed.user,
      });
  }

  listener() {
    this.state$.subscribe(value => {
      this.storage.persistToStorage(this.storageKey, value);
    });
  }

  login = (email: string, password: string) => {
    this.loader.show();
    firebase
      .signInWithEmailAndPassword(firebase.auth, email, password)
      .then(this.loginSuccess)
      .catch(this.loginFailure);
  };

  loginSuccess = (resp: UserCredential) => {
    this.loader.hide();
    this.updateState({
      authenticated: true,
      user: { email: resp.user.email ?? undefined },
      error: undefined,
    });
  };

  loginFailure = (error: any) => {
    this.loader.hide();
    let errorMessage = "";
    if (error.code === "auth/user-not-found") {
      errorMessage = "Usuário não encontrado.";
    } else if (error.code === "auth/invalid-credential") {
      errorMessage = "Dados inválidos.";
    } else if (error.code === "auth/wrong-password") {
      errorMessage = "Dados inválidos.";
    } else if (error.code === "auth/configuration-not-found") {
      errorMessage = "Falha no sistema.";
    } else if (error.code === "auth/too-many-requests") {
      errorMessage = "Muitas tentativas. Acesso bloqueado.";
    } else {
      errorMessage = JSON.stringify(error);
      console.error(error);
    }
    this.updateState({
      authenticated: false,
      user: undefined,
      error: errorMessage,
    });
  };

  logout = () => {
    this.updateState({
      authenticated: false,
      user: undefined,
      error: undefined,
    });
  };
}
